import PagePlugin from "../page_plugin";
import Utils from "./utils"
import Carousel from "../optimize_page/carousel"

const utils_helper = new Utils()
const pagePlugin = new PagePlugin()

export default class HtmlHelper {
    constructor() {
        this.trigger_from = ''
    }

    // type 是 next 還是 previous(上下一步)
    async updateSelectedElement(doc, data, type, vid, trigger_from, is_by_step, is_last_step) {
        let target_ele = doc.querySelector(data.selector)

        if (!target_ele && data.plugin_data) {
            target_ele = doc.querySelector(data.plugin_data.selector)
        }

        console.log(`--------trigger_from: ${trigger_from} --------`)
        console.log(`--------data: --------`, data)
        console.log(`--------trigger_from: ${trigger_from} --------`)
        this.trigger_from = trigger_from

        if (!target_ele) {
            console.log('not_found_ele', data)
            return {
                selector: '',
                ref_ele_tag: ''
            }
        } else {
            console.log('found_ele', target_ele)
        }

        let ref_ele_tag = target_ele.tagName

        if (target_ele.closest('[class*="dynamic_card"]')) {
            console.log('overlay_card')
            return
        }

        let update_ele_selector = data.selector
        let callback_data = null
        let carousel_data = null
        if (!window.carousels) {
            window.carousels = {}
        }
        switch (data.type) {
            case 'attribute':
                if (data.attribute.includes('data-aos')) {
                    target_ele.classList.remove('aos-init')
                    target_ele.classList.remove('aos-animate')

                    setTimeout(() => {
                        if (trigger_from !== 'sdk') {
                            target_ele.classList.add('aos-animate')
                        }
                    }, 500)

                }

                if (data.attribute.includes('data-keep-animation')) {
                    this.handleKeepAnimation(data, type, target_ele)
                } else if (data.attribute.includes('data-mix-blend-mode')) {
                    this.handleAnimationMixBlend(data, type, target_ele)
                } else {
                    this.updateAttribute(data, type, target_ele)
                }
                if (data.attribute.includes('data-aos')) {
                    window.AOS.refreshHard();
                }
                
                break
            case 'css':
                this.updateStyle(data, type, target_ele)
                break;
            case 'html':
                if (data.plugin_data) {
                    update_ele_selector = this.updatePluginHTML(data, type, target_ele, vid, trigger_from)
                } else {
                    this.updateHTML(data, type, target_ele)
                }
                break;
            case 'plugin':
                console.log('update_plugin_data', data)
                console.log('update_plugin_selector', data.target_selector)
                // 修改plugin的子元件
                let plugin_ele = target_ele
                if (data.target_selector) {
                    plugin_ele = target_ele.querySelector(data.target_selector)
                }
                console.log('plugin_ele:', plugin_ele)
                this.updatePlugin(data, type, plugin_ele)
                break;
            case 'delete_plugin':
                console.log('-----delete_plugin----')
                update_ele_selector = this.deletePlugin(doc, data, type, vid, trigger_from, is_by_step)
                console.log('delete', update_ele_selector)
                console.log('-----delete_plugin----')
                break

            case 'init_animation':
                let result_ele_2 = this.updateHTML(data, type, target_ele)
                console.log('result_ele_2', result_ele_2)
                update_ele_selector = utils_helper.unique(result_ele_2)
                window.AOS.refreshHard();
                // if (!window.is_opt99_anmation_loaded) {
                //     this.loadAnimationResources()
                // }
                // else {

                // }
                break;
            case 'remove_animation':
                let result_ele = this.updateHTML(data, type, target_ele)
                console.log('result_ele', result_ele)
                update_ele_selector = utils_helper.unique(result_ele)
                break
            case 'highlight_layer':
                let wrapper = target_ele.closest('[opt99-plugin="animation"]')
                let interact_eles = Array.from(wrapper.querySelectorAll('[data-layer-interact]'))
                interact_eles.forEach(interact_ele => {
                    interact_ele.removeAttribute('data-layer-interact')
                    interact(interact_ele).unset()
                })
                if (!data.selector.includes('[animation-bg]')) {
                    target_ele.setAttribute('data-layer-interact', 'true')
                    this.activateInteractive(target_ele, update_ele_selector)
                }
                break
            case 'order_layer':
                console.log('-----order_layer_start_at----')
                target_ele.remove()
                target_ele = doc.querySelector(data.ref_selector)
                this.updateHTML(data, type, target_ele)
                console.log('-----order_layer_end_at----')

                break
            case 'sort_element':
                console.log('-----sort_element_start_at----')
                let result = this.sortElement(data, type, target_ele, vid, trigger_from, doc)
                console.log('sort_result', result)
                callback_data = result
                console.log('-----sort_element_end----')
                break;

            case 'carousel': {
                console.log('-----carousel_start_at----')
                const operates = {
                    create: async () => {
                        if (!window.carousels[data.carousel_id]) {
                            window.carousels[data.carousel_id] = new Carousel(data.carousel_id)
                        }
                        await window.carousels[data.carousel_id].createModel(target_ele, data.seat, type, data.selector)
                    },
                    add_item: () => {
                        window.carousels[data.carousel_id].addItem(type)
                    },
                    remove_item: async () => {
                        await window.carousels[data.carousel_id].removeItem(data.item_id, type)
                    },
                    edit_item: async () => {
                        await window.carousels[data.carousel_id].editItem(data, type)
                    },
                    pagination_show: () => {
                        window.carousels[data.carousel_id].paginationSwitch(data, type)
                    },
                    pagination_color: () => {
                        window.carousels[data.carousel_id].setPaginationColor(data, type)
                    },
                    pre_and_next_show: () => {
                        window.carousels[data.carousel_id].nextAndPrevSwitch(data, type)
                    },
                    pre_and_next_color: () => {
                        window.carousels[data.carousel_id].setNextAndPrevColor(data, type)
                    },
                    autoplay_switch: () => {
                        window.carousels[data.carousel_id].setAutoplay(data, type)
                    },
                    edit_carousel_size: () => {
                        window.carousels[data.carousel_id].setModelSize(data, type)
                    },
                    edit_slides_per_view: () => {
                        window.carousels[data.carousel_id].setSlidesPerView(data, type)
                    },
                    edit_item_style: () => {
                        window.carousels[data.carousel_id].setItemBackground(data, type)
                        window.carousels[data.carousel_id].setItemSize(data, type)
                    },
                    delete: async () => {
                        await window.carousels[data.carousel_id].deleteModel(type)
                    },
                }

                await operates[data.operate]()
                if (!(data.operate === 'delete' && type === 'next') && !(data.operate === 'create' && type === 'previous')) {
                    document.querySelector(`[data-id="${data.carousel_id}"]`).scrollIntoViewIfNeeded()
                    carousel_data = window.carousels[data.carousel_id].getCarouselData()
                    carousel_data.carousel_new_id = Object.keys(window.carousels).pop()
                    carousel_data.selector = window.carousels[data.carousel_id].create_selector
                    data.is_preview ? carousel_data.is_preview = true : carousel_data.is_preview = false
                }
                break
            }

            default:
                console.log('unknown_update_method:', data)
        }

        try {
            if (window.AOS && is_last_step) {

                /* 最後一步重新刷新動畫狀態 */
                setTimeout(() => {
                    console.log('animation-refresh-hard')
                    window.AOS.refreshHard()
                }, 1500)

                /* 因為safari 子元素mix-blend-mode沒用，所以要加這個 */
                if (trigger_from === 'sdk') {
                    let mix_eles = Array.from(document.querySelectorAll('[animation-thing][data-mix-blend-mode]'))
                    mix_eles.forEach(mix_ele => {
                        let value = mix_ele.getAttribute('data-mix-blend-mode')
                        mix_ele.style.setProperty('mix-blend-mode', value)
                    })
                }
                
                
            }
            else {
                console.log('is_last_step1:', window.AOS)
                console.log('is_last_step2:', is_last_step)
            }
        } catch (error) {
            console.error('init_animation_error', error)
        }

        return {
            selector: update_ele_selector,
            ref_ele_tag: ref_ele_tag,
            callback_data: callback_data,
            carousel_data,
        }
    }

    updateAttribute(data, type, target_ele) {
        let new_value = data.new_value
        if (type !== 'next') {
            new_value = data.value
        }
        if (!new_value) {
            new_value = ''
        }

        target_ele.setAttribute(data.attribute, new_value)
        // for shopline lazy load img會顯示不出來的問題 要一起改data-src
        if (data.nodeName === 'IMG' || data.nodeName === 'IFRAME') {
            if (target_ele.hasAttribute('data-src')) {
                target_ele.setAttribute('data-src', new_value)
            }
        }

        if (data.edit_from && data.edit_from === "animation" && data.attribute === 'src') {
            target_ele.querySelector('img').setAttribute('src', new_value)
        }

        console.log('after_update_attribute: ', target_ele)

    }

    updateStyle(data, type, target_ele) {
        if (type === 'next') {
            if (data.new_values) {
                data.new_values.forEach(new_value => {
                    target_ele.style.setProperty(new_value.css, new_value.value);
                })
            } else {
                target_ele.style.setProperty(data.css, data.new_value);
            }

        } else {
            if (data.values) {
                data.values.forEach(value => {
                    target_ele.style.setProperty(value.css, value.value);
                })
            } else {
                target_ele.style.setProperty(data.css, data.value);
            }

        }
    }

    updateHTML(data, type, target_ele) {
        switch (data.method) {
            case 'replaceText':
                if (type === 'next') {
                    target_ele.innerHTML = data.new_value
                } else {
                    target_ele.innerHTML = data.value
                }
                break;
            case 'replace':
                let html = ''
                if (type === 'next') {
                    html = data.new_value
                } else {
                    html = data.value
                }
                if (data.need_new_ele) {
                    let new_ele = utils_helper.createDomByHtmlString(html)
                    target_ele.replaceWith(new_ele)
                    target_ele = new_ele
                } else {
                    target_ele.outerHTML = html
                }

                break;
            default:
                console.log('data', data)
                console.log('target_ele', target_ele)
                console.log('data.method', data.method)
                console.log('data.new_value', data.new_value)
                if (type === 'next') {
                    if (data.ref_selector) {
                        target_ele = document.querySelector(data.ref_selector)
                    }
                    target_ele.insertAdjacentHTML(data.method, data.new_value)
                } else {
                    let parent_ele = document.querySelector(data.original_info.parentSelector)
                    if (parent_ele) {
                        parent_ele.outerHTML = data.original_info.parentOuterHTML
                    }
                    target_ele = parent_ele
                }

        }

        return target_ele
    }

    updatePlugin(data, type, target_ele) {
        let set_value = data.new_value
        if (type !== 'next') {
            set_value = data.value
        }
        console.log('-------step------')
        console.log(type)
        console.log('-------step------')
        console.log('target_ele:', target_ele)
        console.log('-------old value------')
        console.log(data.value)
        console.log('-------old value------')
        console.log('-------new value------')
        console.log(data.new_value)
        console.log('-------new value------')
        console.log('-------plugin_type-------')
        console.log(data.plugin_data.type)
        console.log('-------plugin_type-------')
        switch (data.param_type) {
            case 'css':
                target_ele.style.setProperty(data.param_name, set_value);
                break;
            case 'attribute':
                target_ele.setAttribute(data.param_name, set_value);
                break;
            case 'value':
                target_ele[data.param_name] = set_value
                break;
            default:
                console.log('unknown_update_plugin_type')
        }

        let related_ele = null
        switch (data.plugin_data.type) {
            case 'sales_counter':
                if (data.param_name === 'init') {
                    related_ele = target_ele.querySelector('[name="counter"]')
                }
                break
            case 'online_user':
                if (data.param_name === 'opt99-top') {
                    related_ele = target_ele.querySelector('[name="counter"]')
                }
                break
        }
        if (related_ele) {
            related_ele.innerText = set_value
        }

        if (data.plugin_data.type === 'ba_slider') {

            // 拉窗方向
            if (data.param_name === 'direction') {
                let slider_new = target_ele.querySelector('div[name="slider-new"]')
                let slider_btn = target_ele.querySelector('div[name="opt99-slider-btn"]')
                let start_percent = target_ele.getAttribute('start_percent')
                let input = target_ele.querySelector('input')
                if (set_value === 'horizontal') {
                    slider_btn.style.top = '50%'
                    slider_btn.style.left = `${start_percent}%`
                    slider_new.style.width = `${start_percent}%`
                    slider_new.style.height = 'auto'
                    slider_btn.style.transform = 'translate3d(-50%, -50%, 0)'
                    input.style.transform = ''
                    input.style.appearance = ''
                } else {
                    slider_btn.style.left = '50%'
                    slider_btn.style.top = `${start_percent}%`
                    slider_new.style.width = 'auto'
                    slider_new.style.height = `${start_percent}%`
                    slider_btn.style.transform = 'translate3d(-50%, -50%, 0) rotate(90deg)'
                    input.style.transform = 'rotate(180deg)'
                    input.style.appearance = 'slider-vertical'
                }

            }

            // 預設開窗%數
            if (data.param_name === 'start_percent') {
                let direction = target_ele.getAttribute('direction')
                let slider_new = target_ele.querySelector('div[name="slider-new"]')
                let slider_btn = target_ele.querySelector('div[name="opt99-slider-btn"]')

                if (direction === 'horizontal') {
                    slider_new.style.height = 'auto'
                    slider_new.style.width = `${set_value}%`

                    slider_btn.style.left = `${set_value}%`
                    slider_btn.style.top = '50%'

                } else {
                    slider_new.style.height = `${set_value}%`
                    slider_new.style.width = 'auto'

                    slider_btn.style.left = '50%'
                    slider_btn.style.top = `${set_value}%`

                }
            }

        }

    }

    updatePluginHTML(data, type, target_ele, vid, trigger_from) {
        let return_selector = ''
        if (type === 'next') {
            return_selector = `div[opt99-plugin="${data.plugin_data.type}"][opt99-vid="${vid}"][opt99-id="${data.plugin_data.id}"]`
            let element = utils_helper.createDomByHtmlString(data.new_value)

            // 把插件的vid換成當下所屬的vid
            console.log('set-plugin-vid:', vid)
            element.setAttribute('opt99-vid', vid)

            // 從sdk來的先隱藏
            if (trigger_from === 'sdk') {
                element.style.display = 'none'
                // 根據插件類別移除不要顯示的屬性
                let plugin_type = element.getAttribute('opt99-plugin')
                let disabled_attributes = []
                let container_ele = element.querySelector('div[name="container"]')
                switch (plugin_type) {
                    case 'online_user':
                        disabled_attributes = [
                            'opt99-top', 'opt99-bot', 'opt99-value'
                        ]
                        break;
                    case 'sales_counter':
                        disabled_attributes = [
                            'cal_type', 'multiple', 'init', 'loop', 'repeat_from', 'top'
                        ]
                    default:

                }

                disabled_attributes.forEach(function (disabled_attribute) {
                    container_ele.removeAttribute(disabled_attribute)
                })
            }

            if (data.plugin_data.type === 'ba_slider') {
                let width = target_ele.parentElement.getBoundingClientRect().width
                let container_ele = element.querySelector('div[name="container"]')
                let exist_img = element.querySelector('div[name="container"] > img')
                if (exist_img) {
                    exist_img.remove()
                }

                // 複製原本的圖片
                let copy = target_ele.cloneNode(true)
                copy.style.position = 'relative'
                copy.style.zIndex = '3'
                container_ele.insertAdjacentElement('afterbegin', copy)

                // 調整覆蓋圖片大小
                let new_img = container_ele.querySelector('div[name="slider-new"] > img')
                new_img.style.width = `${width}px`
                new_img.style.maxWidth = `unset`

                // 事件

                pagePlugin.baSlider(element)
                pagePlugin.display()

                // 把原圖片覆蓋為slider
                target_ele.replaceWith(element)
            } else {
                let plugin = document.querySelector(return_selector)
                if (!plugin) {
                    target_ele.insertAdjacentElement(data.method, element)
                }
            }

        } else {
            let parent_ele = document.querySelector(data.original_info.parentSelector)
            if (parent_ele) {
                parent_ele.outerHTML = data.original_info.parentOuterHTML
            }
            return_selector = data.selector
        }

        return return_selector
    }

    deletePlugin(doc, data, type, vid, trigger_from, is_by_step) {
        let target = ''
        let resp_data = ''

        if (type === 'next') {
            target = doc.querySelector(data.plugin_data.selector)
            if (!target) {
                let result = data.plugin_data.selector.replace(/\[opt99-vid="[^"]*"\]/, '');
                target = doc.querySelector(result)
            }

            if (!target) {
                return
            }

            let parent = target.parentElement
            let child_idx = Array.from(parent.children).indexOf(target)
            let plugin_html = target.outerHTML
            resp_data = JSON.parse(JSON.stringify(data))
            resp_data['selector'] = utils_helper.unique(parent)
            resp_data['child_idx'] = child_idx
            resp_data['plugin_html'] = plugin_html

            if (is_by_step === true) {
                resp_data = utils_helper.unique(parent)
            }

            if (data.plugin_data.type === 'ba_slider') {
                let original_img = target.querySelector('div[name="container"] > img').cloneNode(true)
                target.replaceWith(original_img)
            } else {
                target.remove()
            }
        } else {
            target = doc.querySelector(data.selector)
            let plugin_ele = utils_helper.createDomByHtmlString(data.plugin_html)
            console.log('cancel_delte_plugin_ele', plugin_ele)
            console.log('cancel_delte_target', target)
            plugin_ele.setAttribute('opt99-vid', vid)
            let tmp_id = plugin_ele.getAttribute('opt99-id')

            if (data.plugin_data.type === 'ba_slider') {
                pagePlugin.baSlider(plugin_ele)
                pagePlugin.display()
                target.children[data.child_idx].replaceWith(plugin_ele)
            } else {
                target.insertBefore(plugin_ele, target.children[data.child_idx])
            }
            resp_data = `[opt99-plugin="${data.plugin_data.type}"][opt99-vid="${vid}"][opt99-id="${tmp_id}"]`
        }

        console.log('resp_data: ', resp_data)
        return resp_data

    }

    async loadAnimationResources(is_load_interact) {
        try {
            await utils_helper.loadCSS('https://unpkg.com/aos@2.3.1/dist/aos.css');
            console.log('CSS 加載完成');

            await utils_helper.loadJS('https://unpkg.com/aos@2.3.1/dist/aos.js');
            console.log('JS 加載完成');

            if (is_load_interact) {
                await utils_helper.loadJS('https://unpkg.com/interactjs/dist/interact.min.js');
                console.log('JS 加載完成');
            }


            switch (APP_MODE) {
                case 'development':
                    utils_helper.loadCSS('http://localhost:8080/styles/animation.css');
                    break;
                case 'staging':
                    utils_helper.loadCSS('https://optimize-user.isp99.com/optimize/styles/animation.css');
                    break;
                case 'production':
                    utils_helper.loadCSS('https://admin.optimize99.com/optimize/styles/animation.css');
                    break;
            }
            console.log('動畫CSS 加載完成');

            console.log('引入完成');

            window.AOS.init({
                offset: 50 
            })
            window.is_opt99_anmation_loaded = true
        } catch (error) {
            console.error('資源加載失敗:', error);
        }
    }

    handleKeepAnimation(data, type, target_ele) {
        // target_ele 會指向 animation-thing
        console.log('handleKeepAnimation_target_ele', target_ele)
        console.log('handleKeepAnimation_data', data)
        let animation_text = data.new_value
        let layer_img = target_ele.querySelector('img')
        let tmp_layer_img = layer_img.cloneNode(true)
        let light_wrapper = target_ele.querySelector('.opt99-light')
        if (!layer_img) return;
        if (!data.new_value) {
            data.new_value = ''
        }
        if (!data.value) {
            data.value = ''
        }
        // 要移除的情況
        if ((type === 'next' && !data.new_value.includes('light')) || (type === 'previous' && !data.value.includes('light'))) {
            let light_wrapper = target_ele.querySelector('.opt99-light')
            if (light_wrapper) {
                console.log('移除light')
                light_wrapper.replaceWith(tmp_layer_img)
                layer_img = tmp_layer_img
            }
        }

        if (type !== 'next') {
            animation_text = data.value
        }
        if (!animation_text) {
            animation_text = ''
        }

        // 要新增的狀況
        if (animation_text.includes('light') && !light_wrapper) {
            console.log('新增light')
            let img_src = target_ele.querySelector('img').getAttribute('src')
            if (img_src.includes('?')) {
                let tmp_src = new URL(img_src)
                tmp_src.search = "";
                img_src = tmp_src.toString()
            }
            light_wrapper =  `<div></div>`
            light_wrapper = utils_helper.createDomByHtmlString(light_wrapper)
            light_wrapper.classList.add('opt99-light')
            light_wrapper.style['-webkit-mask-image'] = `url("${img_src}")` 
            light_wrapper.style['-webkit-mask-size'] = `cover`
            light_wrapper.style['-webkit-mask-repeat'] = `no-repeat`
            light_wrapper.style['-webkit-mask-position'] = `center`
            light_wrapper.style['mask-image'] = `url("${img_src}")`
            light_wrapper.style['mask-size'] = `cover`
            light_wrapper.style['mask-repeat'] = `no-repeat`
            light_wrapper.style['mask-position'] = `center`
            layer_img.replaceWith(light_wrapper)
            console.log('tmp_layer_img',tmp_layer_img)
            light_wrapper.insertAdjacentElement('afterbegin', tmp_layer_img)
            layer_img = tmp_layer_img
        }


        if (animation_text.includes('light') && light_wrapper) {
            layer_img = light_wrapper
            layer_img.querySelector('img').style.animation = ''; 
        }
        console.log('light_wrapper_before', light_wrapper)
        console.log('layer_img_before',layer_img)
        
        layer_img.style.animation = ''; 
        const animation_props = [];
        if (animation_text.includes('shine')) {
            animation_props.push(`opt99-shine var(--shine-duration) ease-in-out infinite`);
        }
        if (animation_text.includes('arrow-up')) {
            animation_props.push(`opt99-arrowUp var(--arrow-up-duration) var(--arrow-up-delay) ease-in-out infinite`);
        }
        if (animation_text.includes('bounce')) {
            animation_props.push(`opt99-bounce var(--bounce-duration) ease-in-out infinite`);
        }
        if (animation_text.includes('heartbeat')) {
            animation_props.push(`opt99-heartbeat var(--heartbeat-duration) alternate infinite`);
        }
        layer_img.style.animation = animation_props.join(', ');
        console.log('layer_img_after',layer_img)
        this.updateAttribute(data, type, target_ele)
        
        // if ((type === 'next' && data.value === 'light') || (type === 'previous' && data.new_value === 'light')) {
        //     let wrapper = target_ele
        //     console.log('light_target_-1', wrapper)
        //     target_ele = wrapper.querySelector('div')
        //     target_ele.classList.remove('opt99-light')
        //     target_ele.style['-webkit-mask-image'] = `` 
        //     target_ele.style['-webkit-mask-size'] = ``
        //     target_ele.style['-webkit-mask-repeat'] = ``
        //     target_ele.style['-webkit-mask-position'] = ``
        //     target_ele.style['mask-image'] = ``
        //     target_ele.style['mask-size'] = ``
        //     target_ele.style['mask-repeat'] = ``
        //     target_ele.style['mask-position'] = ``
        //     utils_helper.copyAttributes(wrapper, target_ele)
        //     wrapper.outerHTML = target_ele.outerHTML
        //     console.log('light_target_0', wrapper)
        //     let ele = document.querySelector(data.selector)
        //     console.log('light_target_1', ele)
        //     this.activateInteractive(ele, data.selector)
        //     target_ele = ele
        // }

        // let new_value = data.new_value
        // if (type !== 'next') {
        //     new_value = data.value
        // }
        // switch (new_value) {
        //     case 'light':

        //         let wrapper = `<div></div>`
        //         wrapper = utils_helper.createDomByHtmlString(wrapper)
        //         utils_helper.copyAttributes(target_ele, wrapper)
        //         utils_helper.removeAllAttributes(target_ele)

        //         let img_src = target_ele.querySelector('img').getAttribute('src')
        //         if (img_src.includes('?')) {
        //             let tmp_src = new URL(img_src)
        //             tmp_src.search = "";
        //             img_src = tmp_src.toString()
        //         }
        //         target_ele.classList.add('opt99-light')
        //         target_ele.style['-webkit-mask-image'] = `url("${img_src}")` 
        //         target_ele.style['-webkit-mask-size'] = `cover`
        //         target_ele.style['-webkit-mask-repeat'] = `no-repeat`
        //         target_ele.style['-webkit-mask-position'] = `center`
        //         target_ele.style['mask-image'] = `url("${img_src}")`
        //         target_ele.style['mask-size'] = `cover`
        //         target_ele.style['mask-repeat'] = `no-repeat`
        //         target_ele.style['mask-position'] = `center`

        //         let mix_blend_mode = wrapper.getAttribute('data-mix-blend-mode')
        //         if (mix_blend_mode) {
        //             target_ele.style['mix-blend-mode'] = mix_blend_mode
        //         }

        //         wrapper.innerHTML = target_ele.outerHTML
        //         target_ele.outerHTML = wrapper.outerHTML

        //         let ele = document.querySelector(data.selector)
        //         console.log('light_target_2', ele)
        //         this.activateInteractive(ele, data.selector)
        //         this.updateAttribute(data, type, ele)
        //         break;
        //     default:
                
        // }

    }

    handleAnimationMixBlend(data, type, target_ele) {
        console.log('handleAnimationMixBlend',data)
        console.log('handleAnimationMixBlend',target_ele)
        this.updateAttribute(data, type, target_ele)
        let new_value = data.new_value
        if (type !== 'next') {
            new_value = data.value
        }
        let layer_image = target_ele.querySelector('img')
        if (!new_value || new_value === 'null') {
            new_value = 'normal'
        }
      
        if (target_ele.querySelector('.opt99-light')) {
            let light_ele = target_ele.querySelector('.opt99-light')
            light_ele.style.setProperty('mix-blend-mode', new_value);
        }
        else {
            layer_image.style.setProperty('mix-blend-mode', new_value);            
        }
        
    }

    sortElement(data, type, target_ele, vid, trigger_from, doc) {
        let from_ele = doc.querySelector(data.from)
        let to_ele = doc.querySelector(data.to)
        let tmp_ele = doc.createElement('img')
        let callback_data = {}
        if (type !== 'next') {
            from_ele = doc.querySelector(data.new_from)
            to_ele = doc.querySelector(data.new_to)
        }

        console.log('from', from_ele)
        console.log('to', to_ele)
        console.log('excute_sort', type)

        if (to_ele && from_ele) {
            utils_helper.copyAttributes(to_ele, tmp_ele)

            utils_helper.removeAllAttributes(to_ele)
            utils_helper.copyAttributes(from_ele, to_ele)

            utils_helper.removeAllAttributes(from_ele)
            utils_helper.copyAttributes(tmp_ele, from_ele)

            let new_from_selector = utils_helper.unique(to_ele)
            let new_to_selector = utils_helper.unique(from_ele)


            callback_data = {
                new_from_selector: new_from_selector,
                new_to_selector: new_to_selector,
            }

        }


        return callback_data
    }

    checkTagModify(sdk_ref_ele_tags, bk_record_tags) {
        let is_clear = true
        let fail_index = -1
        let fail_count = 0
        for (let idx = 0; idx < bk_record_tags.length; idx++) {
            if (bk_record_tags[idx] !== sdk_ref_ele_tags[idx]) {
                is_clear = false
                fail_index = idx
                fail_count += 1
            }
        }
        let info = {
            now_tags: sdk_ref_ele_tags,
            bk_tags: bk_record_tags,
            fail_index: fail_index,
            is_clear: is_clear,
            fail_count: fail_count
        }
        console.log('checkTagModify', info)
        return info
    }


    activateInteractive(ele, selector) {
        if (this.trigger_from === 'sdk') {
            return
        }
        interact(ele)
            .resizable({
                // 允許從所有邊緣和角落調整大小
                edges: {left: true, right: true, bottom: true, top: true},

                listeners: {
                    start(event) {
                        const target = event.target;
                        // 記錄初始樣式
                        target.setAttribute('data-initial-width', target.style.width);
                        target.setAttribute('data-initial-height', target.style.height);
                        target.setAttribute('data-initial-left', target.style.left);
                        target.setAttribute('data-initial-top', target.style.top);
                    },

                    move(event) {
                        const target = event.target;
                        const parent = target.parentElement;
                        const parentWidth = parent.offsetWidth;
                        const parentHeight = parent.offsetHeight;

                        // 獲取當前位置百分比，默認為 0
                        let xPercent = parseFloat(target.getAttribute('data-x-percent')) || 0;
                        let yPercent = parseFloat(target.getAttribute('data-y-percent')) || 0;

                        // 計算新的寬度和高度百分比
                        const widthPercent = (event.rect.width / parentWidth) * 100;
                        const heightPercent = (event.rect.height / parentHeight) * 100;

                        // 根據 deltaRect 平滑調整左和上的百分比
                        const deltaXPercent = (event.deltaRect.left / parentWidth) * 100;
                        const deltaYPercent = (event.deltaRect.top / parentHeight) * 100;

                        xPercent += deltaXPercent;
                        yPercent += deltaYPercent;

                        // 更新元素樣式
                        Object.assign(target.style, {
                            width: `${widthPercent}%`,
                            height: `${heightPercent}%`,
                            left: `${xPercent}%`,
                            top: `${yPercent}%`,
                        });

                        // 更新自定義屬性
                        target.setAttribute('data-x-percent', xPercent);
                        target.setAttribute('data-y-percent', yPercent);
                        target.setAttribute('data-width-percent', widthPercent);
                        target.setAttribute('data-height-percent', heightPercent);
                    },

                    end(event) {
                        let info = {
                            width: event.target.style.width,
                            height: event.target.style.height,
                            left: event.target.style.left,
                            top: event.target.style.top,
                            initialWidth: event.target.getAttribute('data-initial-width'),
                            initialHeight: event.target.getAttribute('data-initial-height'),
                            initialLeft: event.target.getAttribute('data-initial-left'),
                            initialTop: event.target.getAttribute('data-initial-top'),
                        }
                        console.log('Resize ended:', info);
                        let values = [
                            {
                                "css": "width",
                                "value": info.initialWidth
                            },
                            {
                                "css": "height",
                                "value": info.initialHeight
                            },
                            {
                                "css": "left",
                                "value": info.initialLeft
                            },
                            {
                                "css": "top",
                                "value": info.initialTop
                            },
                        ]
                        let new_values = [
                            {
                                "css": "width",
                                "value": info.width
                            },
                            {
                                "css": "height",
                                "value": info.height
                            },
                            {
                                "css": "left",
                                "value": info.left
                            },
                            {
                                "css": "top",
                                "value": info.top
                            },
                        ]

                        let data = {
                            type: "css",
                            selector: selector,
                            css: "",
                            values: values,
                            new_values: new_values,
                        }
                        const action = {
                            action: 'interact_result',
                            data: data,
                        }
                        parent.postMessage(action, '*');

                    },
                },

                modifiers: [
                    // 確保邊緣在父元素內部
                    interact.modifiers.restrictEdges({
                        outer: 'parent',
                    }),

                    // 設置最小大小
                    interact.modifiers.restrictSize({
                        min: {width: 10, height: 5}, // 10% 寬度, 5% 高度
                    }),
                ],

                inertia: true,
            })
            .draggable({
                listeners: {
                    start(event) {
                        const target = event.target;
                        // 記錄初始樣式
                        target.setAttribute('data-initial-left', target.style.left);
                        target.setAttribute('data-initial-top', target.style.top);
                    },

                    move(event) {
                        const target = event.target;
                        const parent = target.parentElement;
                        const parentWidth = parent.offsetWidth;
                        const parentHeight = parent.offsetHeight;

                        // 獲取當前位置百分比，默認為 0
                        let xPercent = parseFloat(target.getAttribute('data-x-percent')) || 0;
                        let yPercent = parseFloat(target.getAttribute('data-y-percent')) || 0;

                        // 計算新的位置百分比
                        xPercent += (event.dx / parentWidth) * 100;
                        yPercent += (event.dy / parentHeight) * 100;

                        // 更新元素樣式
                        Object.assign(target.style, {
                            left: `${xPercent}%`,
                            top: `${yPercent}%`,
                        });

                        // 更新自定義屬性
                        target.setAttribute('data-x-percent', xPercent);
                        target.setAttribute('data-y-percent', yPercent);
                    },

                    end(event) {
                        let info = {
                            left: event.target.style.left,
                            top: event.target.style.top,
                            initialLeft: event.target.getAttribute('data-initial-left'),
                            initialTop: event.target.getAttribute('data-initial-top'),
                        }
                        let values = [
                            {
                                "css": "left",
                                "value": info.initialLeft
                            },
                            {
                                "css": "top",
                                "value": info.initialTop
                            },
                        ]
                        let new_values = [
                            {
                                "css": "left",
                                "value": info.left
                            },
                            {
                                "css": "top",
                                "value": info.top
                            },
                        ]

                        let data = {
                            type: "css",
                            selector: selector,
                            css: "",
                            values: values,
                            new_values: new_values,
                        }
                        const action = {
                            action: 'interact_result',
                            data: data,
                        }
                        parent.postMessage(action, '*');
                        console.log('Drag ended:', info);
                    },
                },

                inertia: true,

                modifiers: [
                    interact.modifiers.restrictRect({
                        restriction: {
                            top: -Infinity, // 允許負值
                            left: -Infinity, // 允許負值
                            bottom: Infinity,
                            right: Infinity,
                        },
                        endOnly: true,
                    }),
                ],
            });

    }
}
